import React from 'react'
import { getColor } from './utils'
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis,
    PolarRadiusAxis, Radar, BarChart, Bar, ComposedChart, Label, Cell, LabelList
} from 'recharts'

export const HealthDomainChart = ({ data, height = 250, y_axis = 350, branded = false }) => {
    const textColor = branded ? '#e6e2da' : '#4C6072'
    const gridColor = branded ? 'rgba(230, 226, 218, 0.2)' : 'rgba(0, 0, 0, 0.1)'
    const labelColor = branded ? '#c5beb3' : '#666'

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                data={data.labels.map((label, i) => ({
                    name: label.replace(/_/g, ' '),
                    value: data.values[i]
                }))}
                layout="horizontal"
                margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
                <XAxis
                    dataKey="name"
                    type="category"
                    tick={{ fontSize: 10, angle: -20, dy: 20, fill: textColor }}
                    interval={0}
                />
                <YAxis
                    type="number"
                    domain={[0, y_axis]}
                    tick={{ fill: textColor }}
                />
                <Tooltip
                    contentStyle={branded ? {
                        backgroundColor: '#1a1a1a',
                        border: '1px solid #252525',
                        color: '#e6e2da'
                    } : undefined}
                />
                <Bar
                    dataKey="value"
                    barSize={30}
                >
                    {data.values.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={getColor(entry)} />
                    ))}
                    <LabelList
                        dataKey="value"
                        position="top"
                        formatter={(value) => value.toFixed(1)}
                        style={{ fill: labelColor, fontSize: 12 }}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

export const WeeklyAllocationChart = ({ data }) => (
    <ResponsiveContainer width="100%" height={200}>
        <BarChart
            data={data.labels.map((label, i) => ({
                name: label,
                value: data.values[i]
            }))}
            layout="vertical"
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
                type="number"
                domain={[0, 'auto']}
            />
            <YAxis
                dataKey="name"
                type="category"
                width={140}
                tick={{ fontSize: 12 }}
            />
            <Tooltip />
            <Bar dataKey="value" fill="#8884d8" barSize={20} />
        </BarChart>
    </ResponsiveContainer>
)
